import React, {useRef} from "react";
// import printJS from "print-js";
import { CalendarSharerItems as SharerItems } from "./CalendarSharerItems";
import { ActionsPopup } from "./ActionsPopup";
import copy from "copy-to-clipboard";
export const ActionBar = React.memo(
  ({
    uid,
      euid,
    availableViews,
    view,
    changeView,
    year,
    openFilterPopup,
    filteredEvents
  }) => {
    const [shareActive, setShareActive] = React.useState(false);
    const [actionsPopupActive, setActionsPopupActive] = React.useState(false);

    const button1 = useRef();
    const button2 = useRef();

    const print = () => {
      // printJS({
      //   printable: "printable",
      //   type: "html",
      //   css: "/wp-content/themes/jaarkalender/assets/css/style.min.css"
      // });
      window.print();
    };

    const copyViewLink = () => {
        copy('https://jaarkalender.nl/?agenda=&bekijk=' + uid);
        button1.current?.classList.add('copied');
        button2.current?.classList.remove('copied');

    }
      const copyEditLink = () => {
          copy('https://jaarkalender.nl/?agenda=&bewerk=' + euid);
          button2.current?.classList.add('copied');
          button1.current?.classList.remove('copied');
      }
    const downloadLink = `${
      wp.url.replace(/https?:\/\//, "webcal://")
    }?action=abonneer&id=${uid}`;

      const printLink = `${
          wp.url
      }?action=print&id=${uid}`;

    return (
      <>
        {window.innerWidth < 991 && (
          <ActionsPopup
            isActive={actionsPopupActive}
            setIsActive={setActionsPopupActive}
            print={print}
            downloadLink={downloadLink}
            printLink={printLink}
            filteredEvents={filteredEvents}
            helpLink={'/uitleg/?id=' + uid}
            copyViewLink={copyViewLink}
            copyEditLink={copyEditLink}
            uid={uid}
            euid={euid}
          />
        )}

        <div className="calendar__actionBar">
          <div className="calendar__actions">
            {window.innerWidth < 991 ? (
              <>
                <button className="btn" onClick={() => openFilterPopup()}>
                  <i className="fal fa-filter"></i>Filters
                </button>
                <button
                  className="btn"
                  onClick={() => setActionsPopupActive(true)}
                >
                  <i className="fal fa-ellipsis-h-alt"></i>Acties
                </button>
              </>
            ) : (
              <>
                <a className="btn print-trigger" href={printLink}
                   target="_blank">
                  <i className="fal fa-print"></i>Print
                </a>
                <a
                  className="btn download-ics-trigger"
                  /*href={downloadLink}*/href={'/uitleg/?id=' + uid}
                  target="_blank"
                >
                  <i className="fal fa-download"></i>Abonneer
                </a>
                  <a
                      className="btn download-ics-trigger"
                      href={'/uitleg/?id=' + uid}
                      target="_self"
                  >
                      <i className="fal fa-question"></i>Hulp nodig?
                  </a>
                  <div className={`sharer ${shareActive ? "active" : ""}`}>
                      <button
                          className="btn btn--shareToggle"
                          onClick={() => setShareActive(!shareActive)}
                      >
                          <i className="fal fa-share-alt"></i>
                          <i className="fal fa-times"></i>
                          <span className="screen-reader-text">Share</span>
                      </button>
                      <SharerItems
                          filteredEvents={filteredEvents}
                          onShare={() => setShareActive(false)}
                      />
                  </div>
              </>
            )}
          </div>
          <div className="calendar__viewSelection">
            <span>Weergave</span>
            <ul>
              {availableViews.map((v, index) => (
                <li key={index}>
                  <button
                    data-view={v}
                    type="button"
                    className={`btn calender__changeViewBtn ${v} ${
                      v === view ? "active" : ""
                    }`}
                    onClick={() => changeView(v)}
                  ></button>
                </li>
              ))}
            </ul>
          </div>
        </div>

          { false && (<div className="calendar__actionBar hide-on-mobile">
              <div className="calendar__actions">
                  {uid && (<button className="btn" ref={button1} onClick={() => copyViewLink()}>
                      <i className="fal fa-copy icon-default"></i><i className="fal fa-check icon-active"></i>Copy Bekijklink
                  </button>)}
                  {euid && (<button className="btn" ref={button2} onClick={() => copyEditLink()}>
                      <i className="fal fa-copy icon-default"></i><i className="fal fa-check icon-active"></i>Copy Bewerklink
                  </button>)}

              </div>
          </div>)}
      </>
    );
  }
);
